module.exports = __webpack_public_path__ + "6e0d7686e0ff35f9f28bd6ddd2494391.svg";